import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { LOCALES } from '@/constants'
import { updateDayjsLocale } from '@/utils/dayjs'

// Import translation files from new modular structure
import enTranslations from './locales/en/index.js'
import viTranslations from './locales/vi/index.js'
import nlTranslations from './locales/nl/index.js'

const resources = {
  [LOCALES.EN]: {
    translation: enTranslations
  },
  [LOCALES.VI]: {
    translation: viTranslations
  },
  [LOCALES.NL]: {
    translation: nlTranslations
  }
}

// Get saved language from localStorage or default to English
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage && Object.values(LOCALES).includes(savedLanguage)) {
    return savedLanguage
  }
  return LOCALES.EN // default language
}

const initialLanguage = getInitialLanguage()

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: LOCALES.EN,
    debug: import.meta.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false // react already does escaping
    }
  })

// Sync dayjs locale with i18n language changes
i18n.on('languageChanged', (lng) => {
  updateDayjsLocale(lng)
})

// Initialize dayjs with current language
updateDayjsLocale(initialLanguage)

export default i18n

